'use strict';

/**
 * @ngdoc filter
 * @name gfcmsApp.filter:displayName
 * @function
 * @description
 * # displayName
 * Filter in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .filter('displayName', function () {
    return function (user) {
      if(angular.isUndefined(user) || user === null || !user.firstName)
      {
        return '  ';
      }
      //return user.firstName + ' ' + user.lastName;
      return user.lastName + ', ' + user.firstName;
    };
  });
